import { render, staticRenderFns } from "./BulkDocumentsDeleteDialog.vue?vue&type=template&id=6b64a798&scoped=true"
import script from "./BulkDocumentsDeleteDialog.vue?vue&type=script&lang=js"
export * from "./BulkDocumentsDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64a798",
  null
  
)

export default component.exports